import { Outlet } from "react-router-dom";
import { MeNav } from "@/components/me/me-nav";

export function MeLayout() {
  return (
    <div className="min-h-screen bg-background pb-20">
      <MeNav />
      <main className="mx-auto max-w-lg px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
